<template>
  <div class="dropdown-menu">
    <button
      ref="dropdown_menu"
      class="toogle-panel-btn"
      @click="show_menu = !show_menu"
    >
      <span class="mdi mdi-dots-vertical"></span>
    </button>
    <div
      class="menus"
      @click="show_menu = !show_menu"
      v-closable="{ exclude: ['dropdown_menu'], handler: 'hideMenu' }"
      v-show="show_menu"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "dropdown-menu",
  components: {},
  props: ["visible"],
  data: () => {
    return {
      show_menu: false,
    };
  },
  watch: {
    visible: function (val) {
      this.show_menu = val;
    },
  },
  mounted() {},
  methods: {
    hideMenu() {
      this.show_menu = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu {
  position: relative;
  .toogle-panel-btn {
    font-size: 25px;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    color: #ccc;
    height: 41px;
    width: 14px;
    display: flex;
    align-items: center;
  }
  .menus {
    position: absolute;
    top: 38px;
    left: -121px;
    background: #fff;
    z-index: 9999;
    padding-top: 0px;
    padding-bottom: 0px;
    min-width: 145px;
    border-radius: 5px;
    box-shadow: 0px 0px 3px #ccc;
    ul {
      list-style: none;
      margin-left: -24px !important;
      margin-top: 0px;
      margin-bottom: 0px;
      li {
        a {
          padding: 13px 10px;
          text-decoration: none;
          color: #000;
          display: block;
          font-family: "AvenirBook";
          border-bottom: 1px solid #f5f5f5;
        }
      }
      li:hover {
        a {
          background: #f5f5f5;
        }
      }
    }
  }
}
</style>
